import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ListboxModule } from 'primeng/listbox';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { MessagesModule } from 'primeng/messages';
import { MultiSelectModule } from 'primeng/multiselect';
import { PanelMenuModule } from 'primeng/panelmenu';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SlideMenuModule } from 'primeng/slidemenu';
import { SplitButtonModule } from 'primeng/splitbutton'
import { TableModule } from 'primeng/table';
import { TabMenuModule } from 'primeng/tabmenu';
import { TabViewModule } from 'primeng/tabview';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TooltipModule } from 'primeng/tooltip';

import { AppComponent } from './app.component';
import { Globals } from './globals';

import { SupportingWindowTogglerComponent } from './Components/SupportingWindowToggler/SupportingWindowToggler.component';
import { StudentEnrollmentsComponent } from './Components/StudentEnrollments/StudentEnrollments.component';
import { ActivityLogComponent } from './Components/ActivityLog/ActivityLog.component';
import { AssessmentComponent } from './Components/Assessment/Assessment.component';
import { CALPADSComponent } from './Components/CALPADS/CALPADS.component';
import { MyDashboardComponent } from './Components/MyDashboard/MyDashboard.component';
import { IEPAPComponent } from './Components/IEP-AP/IEP-AP.component';
import { IEPInformationComponent } from './Components/iep/IEPInformation/IEPInformation.component';
import { InitialIEPInfoComponent } from './Components/iep/InitialIEPInfo/InitialIEPInfo.component';
import { ReportsComponent } from './Components/Reports/Reports.component';
import { MaintenanceComponent } from './Components/Maintenance/Maintenance.component';
import { SelectedStudentComponent } from './Components/SelectedStudent/SelectedStudent.component';
import { ServiceDocumentationComponent } from './Components/ServiceDocumentation/ServiceDocumentation.component';
import { AssignServiceToStaffComponent } from './Components/ServiceDocumentation/AssignServiceToStaff/AssignServiceToStaff.component';
import { IEPProgressReportComponent } from './Components/ServiceDocumentation/IEPProgressReport/IEPProgressReport.component';
import { IEPServiceLogByProviderComponent } from './Components/ServiceDocumentation/IEPServiceLogByProvider/IEPServiceLogByProvider.component';
import { ProgressReportsServiceLogsComponent } from './Components/ServiceDocumentation/ProgressReportsServiceLogs/ProgressReportsServiceLogs.component';
import { SinglePageServiceDocumentationComponent } from './Components/ServiceDocumentation/SinglePageServiceDocumentation/SinglePageServiceDocumentation.component';
import { StudentServicesComponent } from './Components/StudentServices/StudentServices.component';
import { SPTProcessComponent } from './Components/StudentServices/SPTProcess/SPTProcess.component';
import { ChildFindFollowupComponent } from './Components/StudentServices/ChildFindFollowup/ChildFindFollowup.component';

import { StudentSearchComponent } from './Components/StudentSearch/StudentSearch.component';
import { DocumentDashboardComponent } from './Components/DocumentDashboard/DocumentDashboard.component';

import { AdminPlacementComponent } from './Components/AdminPlacement/AdminPlacement.component';

/**IEP Forms Components**/
import { FormAccomodationsComponent } from "./Components/iep/forms/Accomodations/Accomodations.component";
import { FormAgeOfMajority17Component } from "./Components/iep/forms/AgeOfMajority17/AgeOfMajority17.component";
import { FormAgeOfMajority18Component } from "./Components/iep/forms/AgeOfMajority18/AgeOfMajority18.component";
import { FormAssessmentTeamSummaryComponent } from './Components/iep/forms/AssessmentTeamSummary/AssessmentTeamSummary.component';
import { FormAuthorizationForDisclosure } from './Components/iep/forms/AuthorizationForDisclosure/AuthorizationForDisclosure.component';
import { FormBehaviorPlanComponent } from './Components/iep/forms/BehaviorPlan/BehaviorPlan.component';
import { FormCaliforniaAssessmentTestComponent } from "./Components/iep/forms/CaliforniaAssessmentTest/CaliforniaAssessmentTest.component";
import { FormConferenceFollowupComponent } from "./Components/iep/forms/ConferenceFollowup/ConferenceFollowup.component";
import { FormMeetingNotificationComponent } from './Components/iep/forms/MeetingNotification/MeetingNotification.component';
import { FormESYSurveyComponent } from "./Components/iep/forms/ESYSurvey/FormESYSurvey.component";
import { FormELReclassificationComponent } from "./Components/iep/forms/ELReclassification/ELReclassification.component"
import { FormGoalsAndBenchmarksComponent } from './Components/iep/forms/GoalsAndBenchmarks/GoalsAndBenchmarks.component';
import { FormIndividualizedTransitionPlanComponent } from "./Components/iep/forms/IndividualizedTransitionPlan/IndividualizedTransitionPlan.Component";
import { FormLAGOComponent } from './Components/iep/forms/LAGO/LAGO.component';
import { FormManifestationDeterminationComponent } from "./Components/iep/forms/ManifestationDetermination/ManifestationDetermination.component";
import { FormMeetingSignInComponent } from './Components/iep/forms/MeetingSignIn/MeetingSignIn.component';
import { FormNotesComponent } from "./Components/iep/forms/Notes/Notes.component";
import { FormNoticeOfIntentComponent } from "./Components/iep/forms/NoticeOfIntent/NoticeOfIntent.component";
import { FormNotificationOfAppealComponent } from "./Components/iep/forms/NotificationOfAppeal/NotificationOfAppeal.component";
import { FormPermissionToAssessComponent } from "./Components/iep/forms/PermissionToAssess/PermissionToAssess.component";
import { FormPermToAssesRemindComponent } from "./Components/iep/forms/PermToAssessRemind/PermToAssessRemind.component";
import { FormPlanningForTheFutureComponent } from './Components/iep/forms/PlanningForTheFuture/PlanningForTheFuture.component';
import { FormPresentLevelsComponent } from './Components/iep/forms/PresentLevels/PresentLevels.component';
import { FormRevokingConsentComponent } from "./Components/iep/forms/RevokingConsent/RevokingConsent.component";
import { FormSignatureComponent } from './Components/iep/forms/Signature/Signature.component';
import { FormSpecialFactorsComponent } from "./Components/iep/forms/SpecialFactors/SpecialFactors.component";
import { FormStudentInformationComponent } from "./Components/iep/forms/StudentInformation/StudentInformation.component";
import { FormSummaryOfPerformanceComponent } from "./Components/iep/forms/SummaryOfPerformance/SummaryOfPerformance.component";
import { FormSurrogateParentAppointmentComponent } from "./Components/iep/forms/SurrogateParentAppointment/SurrogateParentAppointment.component";

import { FormVisionHearingComponent } from './Components/iep/forms/VisionHearing/VisionHearing.component';
import { EmergencyServiceOptionsComponent } from './Components/iep/forms/emergency-service-options/emergency-service-options.component';

/**IEP Services***/
import { MessageService, ConfirmationService } from 'primeng/api';
import { LookupService } from './Services/LookupService';
import { AdminPlacementService } from './Services/AdminPlacementService';
import { CALPADSService } from './Services/CALPADSService';


import { UserService } from './Services/UserService';
import { SecurityService } from './Services/SecurityService';
import { StudentSearchService } from "./Services/StudentSearchService";
import { StudentService } from "./Services/StudentService";
import { ServicesService } from "./Services/ServicesService";
import { DashboardDocumentService } from "./Services/DashboardDocumentService";
import { IepService } from "./Services/IepService";
import { SiteService } from "./Services/SiteService";
import { InitialIEPInfoService } from './Services/InitialIEPInfoService';
import { ChildFindFollowupService } from './Services/ChildFindFollowupService';
import { SPTProcessService } from './Services/SPTProcessService';
import { ReportService } from "./Services/ReportService";
import { SISStudentService } from "./Services/SISStudentService";
import { ActivityLogService } from "./Services/ActivityLogService";
import { CaseloadService } from "./Services/CaseloadService";
import { MaintenanceService } from "./Services/MaintenanceService";
import { SinglePageServiceDocumentationService } from "./Services/SinglePageServiceDocumentationService";
import { OasisService } from "./Services/OasisService"
import { SelectedStudentService } from './Services/SelectedStudentService';

/**IEP Forms Services***/
import { FormAccomodationsService } from './Services/FormAccomodationsService';
import { FormAgeOfMajority17Service } from './Services/FormAgeOfMajority17Service';
import { FormAgeOfMajority18Service } from './Services/FormAgeOfMajority18Service';
import { FormAssessmentTeamSummaryService } from './Services/FormAssessmentTeamSummaryService';
import { FormAuthorizationForDisclosureService } from './Services/FormAuthorizationForDisclosureService';
import { FormBehaviorPlanService } from './Services/FormBehaviorPlanService';
import { FormCaliforniaAssessmentTestService } from "./Services/FormCaliforniaAssessmentTestService";

import { FormConferenceFollowupService } from "./Services/FormConferenceFollowupService";
import { FormConferenceInvitationService } from './Services/FormConferenceInvitationService';
import { FormESYSurveyService } from "./Services/FormESYSurveyService";
import { FormELReclassificationService } from "./Services/FormELReclassificationService";
import { FormEmergencyServicesOptionsService } from './Services/FormEmergencyServicesOptions.service';
import { FormGoalsAndBenchmarksService } from './Services/FormGoalsAndBenchmarksService';
import { FormIndividualizedTransitionPlanService } from "./Services/FormIndividualizedTransitionPlanService";
import { FormLAGOService } from './Services/FormLAGOService';
import { FormManifestationDeterminationService } from './Services/FormManifestationDeterminationService';
import { FormMeetingSignInService } from './Services/FormMeetingSignInService';
import { FormNotesService } from './Services/FormNotesService';
import { FormNoticeOfIntentService } from "./Services/FormNoticeOfIntentService";
import { FormNotificationOfAppealService } from "./Services/FormNotificationOfAppealService";
import { FormPermissionToAssessService } from './Services/FormPermissionToAssessService';
import { FormPermToAssessRemindService } from './Services/FormPermToAssessRemindService';
import { FormPlanningForTheFutureService } from "./Services/FormPlanningForTheFutureService";
import { FormPresentLevelsService } from './Services/FormPresentLevelsService';
import { FormRevokingConsentService } from "./Services/FormRevokingConsentService";
import { FormSignatureService } from './Services/FormSignatureService';
import { FormSpecialFactorsService } from './Services/FormSpecialFactorsService';
import { FormStudentInformationService } from './Services/FormStudentInformationService';
import { FormSurrogateParentAppointmentService } from "./Services/FormSurrogateParentAppointmentService";
import { FormSummaryOfPerformanceService } from "./Services/FormSummaryOfPerformanceService";
import { FormVisionHearingService } from './Services/FormVisionHearingService';

import { multicast } from 'rxjs/operators';


//ADDED BY KEITH ISRAEL 20191709
import { _100_PSEdReportParametersComponent } from './Components/Reports/_100_PSEdReportParameters/_100_PSEdReportParameters.component';
import { _101_AdminPlacementDueReportParametersComponent } from './Components/Reports/_101_AdminPlacementDueReportParameters/_101_AdminPlacementDueReportParameters.component';
import { _105_30DayComplianceReportParamsComponent } from './Components/Reports/_105_30DayComplianceReportParams/_105_30DayComplianceReportParams.component';
import { _115_ProviderCaseloadReportParametersComponent } from './Components/Reports/_115_ProviderCaseloadReportParameters/_115_ProviderCaseloadReportParameters.component';
import { _116_ProviderProgressReportParametersComponent } from './Components/Reports/_116_ProviderProgressReportParameters/_116_ProviderProgressReportParameters.component';
import { _118_SpecialEducationCaseloadRptParamsComponent } from './Components/Reports/_118_SpecialEducationCaseloadRptParams/_118_SpecialEducationCaseloadRptParams.component';
import { _120ServiceRegistersReportParamsComponent } from './Components/Reports/_120ServiceRegistersReportParams/_120ServiceRegistersReportParams.component';
import { _121_CertifyServiceRegisterReportComponent } from './Components/Reports/_121_CertifyServiceRegisterReport/_121_CertifyServiceRegisterReport.component';
import { _125_ServicesDeliveredSummaryRptParamsComponent } from './Components/Reports/_125_ServicesDeliveredSummaryRptParams/_125_ServicesDeliveredSummaryRptParams.component';
import { _126_ServicesDeliveredDetailRptParamsComponent } from './Components/Reports/_126_ServicesDeliveredDetailRptParams/_126_ServicesDeliveredDetailRptParams.component';
import { _126_ServicesDeliveredDetailSELPAComponent } from './Components/Reports/_126_ServicesDeliveredDetailSELPA/_126_ServicesDeliveredDetailSELPA.component';
import { IEPSummaryComponent } from './Components/Reports/_130_IEPSummary/IEPSummary.component';
import { _201_AdministrativeServiceComplianceRptParamsComponent } from './Components/Reports/_201_AdministrativeServiceComplianceRptParams/_201_AdministrativeServiceComplianceRptParams.component';
import { _202_SpecialEducationStudentsDisabilitiesRptComponent } from './Components/Reports/_202_SpecialEducationStudentsDisabilitiesRpt/_202_SpecialEducationStudentsDisabilitiesRpt.component';
import { _310_IEPComplianceReportParamsComponent } from './Components/Reports/_310_IEPComplianceReportParams/_310_IEPComplianceReportParams.component';
import { _315_OutOfComplianceRptParamsComponent } from './Components/Reports/_315_OutOfComplianceRptParams/_315_OutOfComplianceRptParams.component';
import { _320_IEPBatchPrintReportsComponent } from './Components/Reports/_320_IEPBatchPrintReports/_320_IEPBatchPrintReports.component';
import { _400_ExcelBasedReportsComponent } from './Components/Reports/_400_ExcelBasedReports/_400_ExcelBasedReports.component';
import { _401_MissingStudentIdReportComponent } from './Components/Reports/_401_MissingStudentIdReport/_401_MissingStudentIdReport.component';
import { StudentComplianceReport_Level_1_Component } from './Components/Reports/StudentComplianceReport_Level_1_/StudentComplianceReport_Level_1_.component';
import { ScannedDocumentsComponent } from './Components/iep/scanned-documents/scanned-documents.component';
import { _500_ProgressReportComponent } from './Components/Reports/_500_ProgressReport/_500_ProgressReport.component';

export function loggerCallback(loglevel, message, piiEnabled) {
  console.log("client logging", message);
}

export const protectedResourceMap: [string, string[]][] = [
  ['https://graph.microsoft.com/v1.0/me', ['user.read']]
  // ... other scopes
];

const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

@NgModule({
  declarations: [
    AppComponent,
    SupportingWindowTogglerComponent,
    StudentEnrollmentsComponent,
    ActivityLogComponent,
    AssessmentComponent,
    CALPADSComponent,
    MyDashboardComponent,
    DocumentDashboardComponent,
    IEPAPComponent,
    IEPInformationComponent,
    InitialIEPInfoComponent,
    SPTProcessComponent,
    ChildFindFollowupComponent,
    ReportsComponent,
    MaintenanceComponent,
    SelectedStudentComponent,
    ServiceDocumentationComponent,
    AssignServiceToStaffComponent,
    IEPProgressReportComponent,
    IEPServiceLogByProviderComponent,
    ProgressReportsServiceLogsComponent,
    SinglePageServiceDocumentationComponent,
    StudentServicesComponent,
    StudentSearchComponent,
    AdminPlacementComponent,

    /**IEP Forms Components**/
    FormAccomodationsComponent,
    FormAgeOfMajority17Component,
    FormAgeOfMajority18Component,
    FormAssessmentTeamSummaryComponent,
    FormAuthorizationForDisclosure,
    FormVisionHearingComponent,
    FormBehaviorPlanComponent,
    FormCaliforniaAssessmentTestComponent,
    FormConferenceFollowupComponent,
    FormMeetingNotificationComponent,
    FormESYSurveyComponent,
    FormELReclassificationComponent,
    FormGoalsAndBenchmarksComponent,
    FormIndividualizedTransitionPlanComponent,
    FormLAGOComponent,
    FormManifestationDeterminationComponent,
    FormMeetingSignInComponent,
    FormNotesComponent,
    FormNoticeOfIntentComponent,
    FormNotificationOfAppealComponent,
    FormPermissionToAssessComponent,
    FormPermToAssesRemindComponent,
    FormPlanningForTheFutureComponent,
    FormPresentLevelsComponent,
    FormRevokingConsentComponent,
    FormSignatureComponent,
    FormSpecialFactorsComponent,
    FormStudentInformationComponent,
    FormSummaryOfPerformanceComponent,
    FormSurrogateParentAppointmentComponent,
    FormVisionHearingComponent,
    EmergencyServiceOptionsComponent,

    //ADDED BY KEITH ISRAEL 20191709
    /**Report Components**/
    _100_PSEdReportParametersComponent,
    _101_AdminPlacementDueReportParametersComponent,
    _105_30DayComplianceReportParamsComponent,
    _115_ProviderCaseloadReportParametersComponent,
    _116_ProviderProgressReportParametersComponent,
    _118_SpecialEducationCaseloadRptParamsComponent,
    _120ServiceRegistersReportParamsComponent,
    _121_CertifyServiceRegisterReportComponent,
    _125_ServicesDeliveredSummaryRptParamsComponent,
    _126_ServicesDeliveredDetailRptParamsComponent,
    _126_ServicesDeliveredDetailSELPAComponent,
    IEPSummaryComponent,
    _201_AdministrativeServiceComplianceRptParamsComponent,
    _202_SpecialEducationStudentsDisabilitiesRptComponent,
    _310_IEPComplianceReportParamsComponent,
    _315_OutOfComplianceRptParamsComponent,
    _320_IEPBatchPrintReportsComponent,
    _400_ExcelBasedReportsComponent,
    _401_MissingStudentIdReportComponent,
    StudentComplianceReport_Level_1_Component,
    ScannedDocumentsComponent,
    _500_ProgressReportComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    CheckboxModule,
    DialogModule,
    DropdownModule,
    CalendarModule,
    FieldsetModule,
    FileUploadModule,
    InputMaskModule,
    InputNumberModule,
    InputTextModule,
    InputTextareaModule,
    ListboxModule,
    MenuModule,
    MenubarModule,
    MessagesModule,
    MultiSelectModule,
    PanelMenuModule,
    ProgressSpinnerModule,
    RadioButtonModule,
    SlideMenuModule,
    SplitButtonModule,
    TableModule,
    TabMenuModule,
    TabViewModule,
    ConfirmDialogModule,
    TooltipModule,
    RouterModule.forRoot([
      { path: 'SupportingWindowToggler', component: SupportingWindowTogglerComponent },
      { path: 'StudentEnrollments', component: StudentEnrollmentsComponent },
      { path: 'activitylog', component: ActivityLogComponent },
      { path: 'assessment', component: AssessmentComponent },
      { path: 'calpads', component: CALPADSComponent },
      { path: 'dashboard', component: MyDashboardComponent },
      { path: 'iep-ap', component: IEPAPComponent },
      { path: 'iep/InitialIEPInfo', component: InitialIEPInfoComponent },
      { path: 'adminPlacement', component: AdminPlacementComponent },
      { path: 'reports', component: ReportsComponent },
      { path: 'maintenance', component: MaintenanceComponent },
      { path: 'service-documentation', component: ServiceDocumentationComponent },
      { path: 'service-documentation/assignservicetostaff', component: AssignServiceToStaffComponent },
      { path: 'service-documentation/iepprogressreport', component: IEPProgressReportComponent },
      { path: 'service-documentation/iepservicelogbyprovider', component: IEPServiceLogByProviderComponent },
      { path: 'service-documentation/progressreportsservicelogs', component: ProgressReportsServiceLogsComponent },
      { path: 'singlepageservicedocumentation', component: SinglePageServiceDocumentationComponent },
      { path: 'student-services', component: StudentServicesComponent },
      { path: 'student-services/sptprocess', component: SPTProcessComponent },
      { path: 'student-services/childfindfollowup', component: ChildFindFollowupComponent },
      { path: 'Components/StudentSearch/StudentSearch', component: StudentSearchComponent },
      { path: 'iep/forms/Accomodations', component: FormAccomodationsComponent },
      { path: 'iep/forms/ageOfMajority17', component: FormAgeOfMajority17Component },
      { path: 'iep/forms/ageOfMajority18', component: FormAgeOfMajority18Component },
      { path: 'iep/forms/AssessmentTeamSummary', component: FormAssessmentTeamSummaryComponent },
      { path: 'iep/forms/AuthorizationForDisclosure', component: FormAuthorizationForDisclosure },
      { path: 'iep/forms/BehaviorPlan', component: FormBehaviorPlanComponent },     
      { path: 'iep/forms/CaliforniaAssessmentTest', component: FormCaliforniaAssessmentTestComponent },
      { path: 'iep/forms/conferenceFollowup', component: FormConferenceFollowupComponent },
      { path: 'iep/forms/MeetingNotification', component: FormMeetingNotificationComponent },      
      { path: 'iep/forms/ESYSurvey', component: FormESYSurveyComponent },
      { path: 'iep/forms/ELReclassification', component: FormELReclassificationComponent },
      { path: 'iep/forms/GoalsAndBenchmarks', component: FormGoalsAndBenchmarksComponent },
      { path: 'iep/forms/IndividualizedTransitionPlan', component: FormIndividualizedTransitionPlanComponent },
      { path: 'iep/forms/LAGO', component: FormLAGOComponent },
      { path: 'iep/forms/ManifestationDetermination', component: FormManifestationDeterminationComponent },
      { path: 'iep/forms/MeetingSignIn', component: FormMeetingSignInComponent },          
      { path: 'iep/forms/notes', component: FormNotesComponent },
      { path: 'iep/forms/noticeOfIntent', component: FormNoticeOfIntentComponent },
      { path: 'iep/forms/notificationOfAppeal', component: FormNotificationOfAppealComponent },
      { path: 'iep/forms/permissionToAssess', component: FormPermissionToAssessComponent },
      { path: 'iep/forms/permissionToAssessReminder', component: FormPermToAssesRemindComponent },
      { path: 'iep/forms/PlanningForTheFuture', component: FormPlanningForTheFutureComponent },
      { path: 'iep/forms/PresentLevels', component: FormPresentLevelsComponent },    
      { path: 'iep/forms/revokingConsent', component: FormRevokingConsentComponent },     
      { path: 'iep/forms/Signature', component: FormSignatureComponent },
      { path: 'iep/forms/SpecialFactors', component: FormSpecialFactorsComponent },
      { path: 'iep/forms/StudentInformation', component: FormStudentInformationComponent },
      { path: 'iep/forms/summaryOfPerformance', component: FormSummaryOfPerformanceComponent },
      { path: 'iep/forms/surrogateParentAppointment', component: FormSurrogateParentAppointmentComponent },
      { path: 'iep/forms/VisionHearing', component: FormVisionHearingComponent },
    ])
  ],
  providers: [
    Globals,
   // { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },  //{ provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
    ActivityLogService,
    CaseloadService,
    MaintenanceService,
    SinglePageServiceDocumentationService,
    AdminPlacementService,
    CALPADSService,
    DashboardDocumentService,
    IepService,
    InitialIEPInfoService,
    ChildFindFollowupService,
    SPTProcessService,
    FormAccomodationsService,
    FormAgeOfMajority17Service,
    FormAgeOfMajority18Service,
    FormAssessmentTeamSummaryService,
    FormAuthorizationForDisclosureService,
    FormBehaviorPlanService,
    FormCaliforniaAssessmentTestService,
    FormConferenceFollowupService,
    FormConferenceInvitationService,
    FormELReclassificationService,
    FormEmergencyServicesOptionsService,
    FormESYSurveyService,
    FormGoalsAndBenchmarksService,
    FormLAGOService,
    FormMeetingSignInService,
    FormManifestationDeterminationService,
    FormNotesService,
    FormNoticeOfIntentService,
    FormNotificationOfAppealService,
    FormPermissionToAssessService,
    FormPermToAssessRemindService,
    FormPlanningForTheFutureService,
    FormPresentLevelsService,
    FormIndividualizedTransitionPlanService,
    FormRevokingConsentService,
    FormSignatureService,
    FormSpecialFactorsService,
    FormStudentInformationService,
    FormSurrogateParentAppointmentService,
    FormSummaryOfPerformanceService,
    FormVisionHearingService,
    MessageService,
    ConfirmationService,
    LookupService,
    ReportService,
    UserService,
    SecurityService,
    SiteService,
    StudentSearchService,
    StudentService,
    ServicesService,
    SISStudentService,
    OasisService,
    SelectedStudentService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
